import React from 'react'


import HurtigtCV from '../../assets/images/hurtigtcv.png'
import TmHelper from '../../assets/images/tmhelper.png'
import AlienLogo from '../../assets/images/ailogo.png'

import './projects-page.css';

export default function ProjectsPage() {
  return (
    <div className='container pt-3' style={{maxWidth: "1100px"}}>
    <h4 className='h4 text-center mb-4'>My Projetcs</h4>
    <p className='text1 text-center'>
      {/* As I am a student I didn't have the possibility to work on many projects outside the curriculum. <br></br> */}
      {/* Here you can find some private and freelance projects that are released and public, some projects from my education and self-induced learning projects. */}
    </p>
      
    <h4 className='h5 text-center'>Published</h4>
    
    <div className='row justify-content-around'>
    
      <div className='col-12 col-md-4 p-3 mt-3 mt-md-0 mb-3'>
        <div className='row text-center'>
          <h6 className='lead'>HurtigtCV</h6>
        </div>
        <div className='text-center'><img src={HurtigtCV} className='project-icon' alt='HurtigtCV'/></div>
        <div className='mt-3'>
          <ul className='list-unstyled text1'>
            <li><b>Case:</b><br/><div className='card-description'>Web presence for a small business;<br/> Requirements: Information about services and prices, and email contact form</div> </li>
            <li><b>Type:</b><br/><div className='card-description'>Website</div> </li>        
            <li><b>Technologies:</b><br/><div className='card-description'>Asp.Net Core Razor Pages</div> </li>
            <li><b>Project:</b><br/><div className='card-description'>1-developer project in close contact with the customer; Included planning, design, implementation, deployment</div> </li>        
          </ul>
        </div>
        <div>Offline since 02/2023</div>
      </div>

      <div className='col-12 col-md-4 p-3 mt-3 mt-md-0'>
        <div className='row text-center'>
          <h6 className='lead'>Terraforming Mars Helper</h6>
        </div>
        <div className='text-center'><img src={TmHelper} className='project-icon' alt='HurtigtCV'/></div>
        <div className='mt-3'>
          <ul className='list-unstyled text1'>
            <li><b>Case:</b><br/><div className='card-description'>Helper App for the boardgame Terraforming Mars for a more convenient calculation and storage of points</div> </li>
            <li><b>Type:</b><br/><div className='card-description'>Mobile/Android</div>  </li>
            <li><b>Technologies:</b><br/><div className='card-description'>C#, Xamarin.Android</div> </li>
            <li><b>Project:</b><br/><div className='card-description'>Personal project; Required to learn about Xamarain and Android first; Duration: 3 weeks</div></li>            
          </ul>
        </div>     
          <a href='https://play.google.com/store/apps/details?id=com.nikod.tmhelper'
          className='btn btn-primary' 
          target='_blank' 
          rel='noreferrer'>View in PlayMarket</a>
      </div>
      
    </div>

    <hr className='divider'/>

    <h4 className='h5 text-center'>Personal projects / Development</h4>

    <div className='row justify-content-center pt-4'>
      <div className='col col-md-4 text-center'>
        <a href='https://polite-stone-00d486503.4.azurestaticapps.net/' target='_blank' rel='noreferrer'>
          <h4>MenuMaker</h4>
        </a>
        <div className='text1'>
        A recipe database with the possibility to make food plans or menues and get a grocery list.<br></br>(An ongoing personal project to keep up to date with .NET and Angular. And also to serve own everyday needs.)<br></br>
        Backend: Asp.Net WebApi<br></br>
        Frontend: Angular/TypeScript<br></br>
        Db: MSSQL Server / PostgreSQL<br></br>
        Hosting: Azure WebApp and StaticWebApp<br></br>
        Local development environment: microk8s<br></br>
        </div>
      </div>
    </div>

    <hr className='divider'/>

    <h4 className='h5 text-center'>Just for fun</h4>

    <div className='row justify-content-center'>
      <div className='col col-md-4 text-center'>
        <a href='http://alieninvaders.azurewebsites.net/' target='_blank' rel='noreferrer'>
          <img src={AlienLogo} alt='Alien Invaders' style={{width: '300px'}}></img>
        </a><br></br>
        <span className='text1'>(a Blazor experiment)</span>
      </div>
    </div>


    <div className='row justify-content-center pt-4'>
      <div className='col col-md-4 text-center'>
        <a href='https://proud-river-095e78003.1.azurestaticapps.net/' target='_blank' rel='noreferrer'>
          <h4>Blazor Weather</h4>
        </a>
        <span className='text1'>(a Blazor experiment)</span>
      </div>
    </div>

    <hr className='divider'/>

    <div className='col mt-3 px-4'>
      <h5 className='h5 text-center'>Coursework</h5>
      <div className='row'>
        <h6 className='h6'>ZPool Ridesharing - 1st Year Exam Project</h6>
        <div className='mx-3'>
          <ul className='list-unstyled text1'>
            <li><b>Assignment:</b> Design and Implement a single user web application (backend, database, frontend)</li>
            <li><b>Type:</b> Web Application (Full-Stack)</li>
            <li><b>Technologies:</b> C#, Asp.Net Core Razor Pages, EF Core, MS SQL Server, Azure</li>
            <li><b>Project:</b> A ridesharing web application for students, to organize rides to and from campus. This project was designed upfront but executed using SCRUM by a 5 person team.</li>            
          </ul>
        </div>
      </div>

      <div className='row'>
      <h6 className='h6'>Zealand Parking - 3rd Semester Exam Project</h6>
      <div className='mx-3'>
          <ul className='list-unstyled text1'>
            <li><b>Assignment: </b> Design and implement an application as a distributed system using a Raspberry Pi, Asp.Net Core WebAPI and Vue.js</li>
            <li><b>Type:</b> Web Application, REST API, IoT </li>
            <li><b>Technologies:</b> C#, Asp.Net Core WepApi, EF Core, JavaScript, Vue.js, Python, Raspberry Pi, MS SQL Server, Azure</li>
            <li><b>Project:</b> Proof of concept for an application that indicates whether there are free parking places on the campus.
              This project was conducted focusing on XP practices as a 4 person team.<br/> The designed and implemented architecture contained: Raspberry Pi with a sensor, Python application to handle sensor data and send it via UDP to a local server, C# appliction to receive sensor data via UDP and post it to a RESTful API, cloudbased SQL Database in  Azure, a Vue.js web application to visualize the gathered data to the end-user </li>            
          </ul>
        </div>
      </div>

      <div className='row'>
        <h6 className='h6'>LånLokalt - 1. semester exam project, WebDevelopment, (B.A.)</h6>
      </div>
        <div className='mx-3'>
          <ul className='list-unstyled text1'>
            <li>Type: WebApp/Mobile</li>
            <li>Technologies: Angular/Ionic, Express.js, MS SQL Server, GitHub, Azure</li>
            <li>Project: Design and implement a web application, that helps local communities to share things and leftover food.</li>  
            <li>Focus on: Ionic frondent with mobile first approach.</li>            
          </ul>
        </div>
    </div>


   <hr className='divider'/>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    
    

  </div>
  )
}
